import * as React from 'react';
import * as Sentry from '@sentry/react';
import { LocationService } from '../services/location/locationService';
import { getBackendLanguage } from '../core/i18n';

export interface AccessibleLocation {
  id: number;
  name: string;
  currency?: string;
}

// Lokalizacje dostepne dla zalogowanego uzytkownika — do selectow lokalizacji
// (kupony, szablony wariantow) i do wyswietlania nazw lokalizacji na listach.
export function useAccessibleLocations() {
  const [locations, setLocations] = React.useState<AccessibleLocation[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    new LocationService()
      .getLocations(getBackendLanguage())
      .then((data: any[]) => {
        if (cancelled) return;
        setLocations((data ?? []).map((l) => ({ id: l.id, name: l.name, currency: l.currency })));
      })
      .catch((error) => {
        console.error('Failed to load locations for location pickers', error);
        Sentry.captureException(error);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { locations, loading };
}
